import { useEffect, useState } from "react";
import { PauseCircle, Mic, Building2, FileText, Dumbbell, Play } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

const MISSING = [[Mic, "15 graded Mock Oral Boards a month"], [Building2, "The researched-department library"], [FileText, "Resume PDF download & AI review"], [Dumbbell, "Fitness Plan (beta)"]];

export function PausedWinBack() {
  const { user, refresh } = useAuth();
  const [sub, setSub] = useState(null);
  const [busy, setBusy] = useState(false);
  const paused = user?.subscription_status === "paused";
  useEffect(() => { if (paused) api.get("/account").then(({ data }) => setSub(data.subscription)).catch(() => {}); }, [paused]);
  if (!paused) return null;
  const until = user.pause_until ? new Date(user.pause_until).toLocaleDateString(undefined, { month: "long", day: "numeric" }) : "";
  const price = sub?.amount ? `$${sub.amount % 1 ? sub.amount.toFixed(2) : sub.amount}` : "the current plan price";
  const resume = async () => {
    if (!window.confirm(`Resume Premium now? Your card will be charged ${price} today and a fresh ${sub?.interval === "year" ? "year" : "month"} of Premium starts immediately.`)) return;
    setBusy(true);
    try { await api.post("/account/subscription/unpause"); toast.success("Premium is back — payment received and a new billing cycle starts today.", { duration: 7000 }); await refresh?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not resume."); } finally { setBusy(false); }
  };
  return (
    <section className="rounded-2xl border border-sky-200 bg-sky-50 dark:bg-sky-950/30 dark:border-sky-900 p-5" data-testid="paused-winback">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1">
          <p className="text-[11px] font-bold uppercase tracking-wider text-sky-700 dark:text-sky-300 flex items-center gap-1.5"><PauseCircle className="w-3.5 h-3.5" /> Premium paused{until ? ` · resumes ${until}` : ""}</p>
          <p className="mt-1 text-sm text-slate-700 dark:text-slate-200">You're on the Free plan until then. Here's what's waiting when you come back:</p>
          <ul className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-1.5">
            {MISSING.map(([Icon, t]) => <li key={t} className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-300"><Icon className="w-4 h-4 text-sky-600 dark:text-sky-400 shrink-0" />{t}</li>)}
          </ul>
        </div>
        <button type="button" onClick={resume} disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-full bg-primary text-white font-bold text-sm px-5 py-2.5 hover:bg-primary/90 disabled:opacity-60 transition-colors shrink-0" data-testid="winback-resume-button">
          <Play className="w-4 h-4" /> {busy ? "Resuming…" : "Resume Premium now"}
        </button>
      </div>
      {sub?.amount && <p className="mt-3 text-[11px] text-slate-500 dark:text-slate-400">Resuming early charges {price} today and starts a new billing {sub.interval === "year" ? "year" : "month"}. Otherwise Premium and billing resume automatically on {until}.</p>}
    </section>
  );
}
